import React, { useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import {
  removeServiceFromCart,
  clearCart,
  increaseQuantity,
  decreaseQuantity,
} from "../../redux/cartSlice";
import CardBookingForm from "./CardBookingForm";
const ViewCartComponent = ({ setCartList }) => {
  const handleClose = () => {
    setCartList(false);
  };

  const cart = useSelector((state) => state.cart.services);

  // console.log(cart);

  const dispatch = useDispatch();


  const [showCardForm, setShowCardForm] =useState(false);


  // if(showCardForm === true){
  //   alert(true);
  // }

  return (
  <>
    <div>
      <div className="view-cart">
        <div className="view-cart-close" onClick={handleClose}></div>

        <div className="view-cart-main">
          <div className="view-cart-top">
            <div></div>
            <div>MY CART</div>
            <span onClick={handleClose}>CLOSE</span>
          </div>

          <div className="view-cart-content">
            {cart?.map((e) => (
              <div className="view-cart-list">
                <div className="view-cart-head">
                  <div>{e.AC_Type} {e.heading}</div>
                  <span>
                    <i
                      onClick={() => dispatch(removeServiceFromCart(e._id))}
                      class="fa-solid fa-trash-can"
                    ></i>
                  </span>
                </div>
                <div className="view-cart-value">
                  <div className="view-cart-quantity">
                    <div
                      className="view-cart-quantity"
                      onClick={() => dispatch(decreaseQuantity(e._id))}
                    >
                      -
                    </div>

                    <span>{e.quantity}</span>
                      <div onClick={() => dispatch(increaseQuantity(e._id))}>
                        +
                      </div>
                    
                  </div>
                  <div className="view-cart-price">₹ {e.discountedPrice}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="view-cart-end">
            <div className="view-cart-total">
              <span>Cart Subtotal :</span>
              <div>
                ₹{" "}
                {cart.reduce((acc, e) => {
                  return acc + Number(e.discountedPrice * e.quantity);
                }, 0)}{" "}
                /-
              </div>
            </div>

            <div
              className="view-cart-button"
              //  onClick={e=> setConfirmForm(true)}

              onClick={e=>  setShowCardForm(true)}
            >
            Book Now 
            </div>
          </div>
        </div>
      </div>
    </div>


    <div>
          {showCardForm && (
        <CardBookingForm setShowCardForm={setShowCardForm}  setCartList={setCartList}  clearCart={clearCart} />
      )}


    </div>
</>


  );
};

export default ViewCartComponent;
